/**
 * LoadingError Component
 * Reusable error display component with retry functionality
 */

import { AlertCircle } from 'lucide-react';
import { getErrorMessage } from '../../lib/api-errors';

interface LoadingErrorProps {
  error: string | Error;
  onRetry?: () => void;
}

export function LoadingError({ error, onRetry }: LoadingErrorProps) {
  const errorMessage = typeof error === 'string' ? error : getErrorMessage(error);

  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-4">
      <div className="flex items-start">
        <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">Error</h3>
          <p className="mt-1 text-sm text-red-700">{errorMessage}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 text-sm font-medium text-red-600 hover:text-red-500 transition-colors"
            >
              Try again →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
